import SearchPanelContainer from './SearchPanelContainer';

export default SearchPanelContainer;
